// @ts-nocheck
import { BACKEND_API_BASE_URL, CLIENT_SOURCE } from "../utilities/constant";
import { getUser, getUserAccessToken } from "../utilities/setting";
import { API_AGENT_ACTIVITY_LOG_BULK } from "./url";

const FLUSH_INTERVAL_MS = 5000;
const FLUSH_BATCH_SIZE = 20;
const MAX_QUEUE = 500; // hard cap so an offline tab can't grow unbounded

let queue = [];
let initialised = false;
let flushing = false;

const endpoint = () => `${BACKEND_API_BASE_URL}${API_AGENT_ACTIVITY_LOG_BULK}`;

function isAgentUser() {
  try {
    return Boolean(getUser()?.agentData);
  } catch {
    return false;
  }
}

function loginTime() {
  try {
    const ts = localStorage.getItem("loginTimestamp");
    return ts ? new Date(Number(ts)).toISOString() : null;
  } catch {
    return null;
  }
}

async function sendBatch(events, useKeepalive = false) {
  if (!isAgentUser()) return false;
  const token = getUserAccessToken();
  if (!token || !events.length) return false;

  const body = JSON.stringify({ events, login_time: loginTime() });

  try {
    if (typeof fetch === "function") {
      const res = await fetch(endpoint(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
          "x-client-source": CLIENT_SOURCE,
        },
        body,
        keepalive: useKeepalive,
      });
      return res.ok;
    }
  } catch {
    
  }

  try {
    if (navigator?.sendBeacon) {
      const url = `${endpoint()}?token=${encodeURIComponent(token)}&x-client-source=${encodeURIComponent(CLIENT_SOURCE)}`;
      const blob = new Blob([body], { type: "application/json" });
      return navigator.sendBeacon(url, blob);
    }
  } catch {
    
  }
  return false;
}

async function flush() {
  if (flushing || queue.length === 0) return;
  if (!getUserAccessToken()) return; 
  flushing = true;
  const batch = queue.slice(0, FLUSH_BATCH_SIZE);
  const ok = await sendBatch(batch, false);
  if (ok) {
    queue = queue.slice(batch.length);
  }
  flushing = false;
  if (ok && queue.length > 0) flush();
}

function flushOnExit() {
  if (queue.length === 0) return;
  while (queue.length > 0) {
    const batch = queue.slice(0, FLUSH_BATCH_SIZE);
    sendBatch(batch, true);
    queue = queue.slice(batch.length);
  }
}

function init() {
  if (initialised || typeof window === "undefined") return;
  initialised = true;

  setInterval(() => {
    if (queue.length > 0) flush();
  }, FLUSH_INTERVAL_MS);

  window.addEventListener("pagehide", flushOnExit);
  window.addEventListener("beforeunload", flushOnExit);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flushOnExit();
  });
}

/**
 * Record one agent action.
 * @param {string} type    canonical activity type (see backend AGENT_ACTIVITY_TYPE)
 * @param {object} details any structured context for the action
 */
export function trackActivity(type, details = {}) {
  try {
    if (!type) return;
    if (!isAgentUser()) return;
    init();
    if (queue.length >= MAX_QUEUE) queue.shift();
    queue.push({
      type: String(type),
      time: new Date().toISOString(),
      details: details && typeof details === "object" ? details : { value: details },
    });
    if (queue.length >= FLUSH_BATCH_SIZE) flush();
  } catch {
  }
}

const APP_LOGOUT_SUPPRESS_MS = 10000;
let appLogoutAt = 0;

export function isAppLogoutInProgress() {
  return Date.now() - appLogoutAt < APP_LOGOUT_SUPPRESS_MS;
}

export function trackAppLogout(details = {}) {
  appLogoutAt = Date.now();
  trackActivity("logout", { scope: "app", ...details });
  flushActivityNow();
}

export function flushActivityNow() {
  try {
    flushOnExit();
  } catch {
    /* ignore */
  }
}

export default trackActivity;
